import BrandingWrapper from "BrandingWrapper";
import config from "config";

import InstanceManagementRoutes from "./instanceManagement/InstanceManagementRoutes";
import LaunchDarklyWrapper from "./LaunchDarklyWrapper";
import AppRoutes from "./Routes";
import ContextWrappers from "./shared/contexts";
import ViewportContextWrapper from "./shared/contexts/ViewportContext";

const RootContent = ({
  isInstanceManagement,
}: {
  isInstanceManagement: boolean;
}) => {
  const Routes = isInstanceManagement ? InstanceManagementRoutes : AppRoutes;

  return (
    <BrandingWrapper>
      <Routes />
    </BrandingWrapper>
  );
};

export const RootContentWithContext = () => {
  const isInstanceManagement = config.isInstanceManagement();

  if (isInstanceManagement) {
    return (
      <LaunchDarklyWrapper>
        <ViewportContextWrapper>
          <RootContent isInstanceManagement={isInstanceManagement} />
        </ViewportContextWrapper>
      </LaunchDarklyWrapper>
    );
  }

  // LaunchDarklyWrapper renders nothing until the flags load or its 3 s
  // timeout ends, so ContextWrappers sits outside it to start its requests
  // at the same time.
  return (
    <ViewportContextWrapper>
      <ContextWrappers>
        <LaunchDarklyWrapper>
          <RootContent isInstanceManagement={isInstanceManagement} />
        </LaunchDarklyWrapper>
      </ContextWrappers>
    </ViewportContextWrapper>
  );
};
